import React from 'react';
import ProductTile from './../product-tile/./product-tile';
//@ts-ignore
import {GetProductsByQuery,GetProductsBySlugs} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import {ReorderProducts,OrderProductsByPrice} from './../../themes/kent/utilities/functions';
//@ts-ignore
import {ModelYear} from './../../themes/kent/utilities/constants';
/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  products?: any;
  parseKey?: any;
  parseValue?: any;
  limit?: any;
  hyperliteSurfHack?:any;
  imageRatio?:any;
  productSlugArray?:any;
  year?:any;
}

interface IState {
  products?:any;
}


class StaggeredList extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state ={};
  }

  componentDidMount = async() =>{
    if(this.props.products){
      let reorderedProducts = await ReorderProducts(this.props.products)
      this.setState({
        'products':reorderedProducts
      })
    } else if(this.props.productSlugArray){
      let productArray = [];
      for (var i = 0; i < this.props.productSlugArray.length; i++) {
        productArray.push(this.props.productSlugArray[i])
      }
      let products = await GetProductsBySlugs(productArray,this.props.year);
      this.setState({
        'products':products
      })
    }
  }

  public render(): JSX.Element {
    if(!this.state.products) return <span />;
    let mobile:any = false;
    if(window.outerWidth < 800 && window.location.pathname.indexOf("fatsac") != -1){
      mobile = true;
    }
    let mobileWidth:any = 300;
    if(mobile){
      return (
        <div className="tiny-padding mobile-horizontal-staggered-scroll">
          {this.state.products.map((data:any,index:any) => {
            return(
              <div key={'subcat-prod-'+index} className={"tiny-padding staggered-product-tile"} style={{maxWidth:mobileWidth+"px", width:mobileWidth+"px",minWidth:mobileWidth+"px"}}>
                <ProductTile
                  year={this.props.year}
                  product={data} />
              </div>
          )})}
        </div>
      );
    } else{
      return (
        <React.Fragment>
          {this.state.products.map((data:any,index:any) => {
            return(
              <div key={'subcat-prod-'+index} className={"small-12 medium-6 tiny-padding staggered-product-tile"}>
                <ProductTile
                  year={this.props.year}
                  product={data} />
              </div>
            )})}
        </React.Fragment>
      );
    }
 }
}

 export default StaggeredList;
